import { ref } from 'vue'
import { defineStore } from 'pinia'
import router from '@/router'
import { signOut } from 'aws-amplify/auth'

interface User {
  name: string
  email: string
  roles: string[]
  avatar: string | null
  amplifyUser?: unknown
}

export const useAuthStore = defineStore('auth', () => {
  const isAuthenticated = ref(false)
  const user = ref<User | null>(null)
  const token = ref<string | null>(null)

  const login = async () => {
    try {
      // Simular login bem-sucedido para desenvolvimento
      await new Promise(resolve => setTimeout(resolve, 1500)) // Simular delay de rede
      
      isAuthenticated.value = true
      token.value = 'mock-token-' + Date.now()
      user.value = {
        name: 'Alexander Melo',
        email: 'alexander.melo@lwsa.com',
        roles: ['developer', 'admin', 'architect'],
        avatar: null
      }
      
      // Salvar no localStorage para persistência
      localStorage.setItem('lwsa_auth_token', token.value)
      localStorage.setItem('lwsa_auth_user', JSON.stringify(user.value))
      
      console.log('Login realizado com sucesso')
    } catch (error) {
      console.error('Erro no login:', error)
      throw error
    }
  }

  // Nova função para login com AWS Amplify
  const loginWithAmplify = async (userData: { name: string; email: string; roles?: string[]; avatar?: string | null }, amplifyUser: unknown) => {
    try {
      console.log('Iniciando login com dados do Amplify...')
      
      isAuthenticated.value = true
      token.value = 'amplify-token-' + Date.now()
      user.value = {
        name: userData.name,
        email: userData.email,
        roles: userData.roles || ['developer'],
        avatar: userData.avatar || null,
        amplifyUser: amplifyUser // Guardar referência do usuário Amplify para uso posterior
      }
      
      // Salvar no localStorage para persistência
      localStorage.setItem('lwsa_auth_token', token.value)
      localStorage.setItem('lwsa_auth_user', JSON.stringify(user.value))
      
      console.log('Login com Amplify realizado com sucesso:', user.value)
    } catch (error) {
      console.error('Erro no login com Amplify:', error)
      throw error
    }
  }

  const logout = async () => {
    console.log('Iniciando processo de logout...')
    
    try {
      // Fazer signOut do AWS Amplify primeiro
      console.log('Fazendo signOut do Amplify...')
      await signOut()
      console.log('SignOut do Amplify concluído')
    } catch (error) {
      console.warn('Erro no signOut do Amplify (usuário pode já estar deslogado):', error)
    }
    
    // Limpar estado
    isAuthenticated.value = false
    user.value = null
    token.value = null
    
    // Limpar localStorage
    localStorage.removeItem('lwsa_auth_token')
    localStorage.removeItem('lwsa_auth_user')
    
    console.log('Estado e localStorage limpos')
    
    // Aguardar um tick para garantir que o Vue processe a mudança de estado
    await new Promise(resolve => setTimeout(resolve, 10))
    
    try {
      console.log('Redirecionando para login...')
      // Redirecionar para login
      await router.push({name: 'Login'})
      console.log('Redirecionamento concluído')
    } catch (error) {
      console.error('Erro no redirecionamento:', error)
      // Forçar redirecionamento se o router falhar
      window.location.href = '/login'
    }
  }

  const initializeAuth = () => {
    // Verificar se há dados de autenticação salvos
    const savedToken = localStorage.getItem('lwsa_auth_token')
    const savedUser = localStorage.getItem('lwsa_auth_user')
    
    if (savedToken && savedUser) {
      try {
        token.value = savedToken
        user.value = JSON.parse(savedUser)
        isAuthenticated.value = true
        console.log('Sessão restaurada')
      } catch (error) {
        console.error('Erro ao restaurar sessão:', error)
        logout()
      }
    }
  }

  return {
    isAuthenticated,
    user,
    token,
    login,
    loginWithAmplify,
    logout,
    initializeAuth
  }
}) 